var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Consultation100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "border-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#487694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#664894"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient-mod",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ba3aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3a7f"
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient-lighter",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#ba3aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3a7f"
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shirt",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#b778ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff78c0"
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brown",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#862926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#838626"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#border-gradient)",
    d: "M 38.5,43.5 C 36.9373,42.0552 35.604,40.3885 34.5,38.5C 33.3862,37.1147 32.3862,35.6147 31.5,34C 27.3123,33.8238 23.3123,33.3238 19.5,32.5C 19.6107,31.8826 19.944,31.3826 20.5,31C 24.8713,30.1725 29.2047,30.3391 33.5,31.5C 34.9213,34.0094 36.5879,36.3428 38.5,38.5C 40.6549,33.8391 44.1549,30.8391 49,29.5C 49.4966,27.1902 49.6633,24.8568 49.5,22.5C 49.6659,17.4889 49.4993,12.4889 49,7.5C 48.6174,6.94404 48.1174,6.61071 47.5,6.5C 34.3397,5.33963 21.0064,5.17296 7.5,6C 7,6.5 6.5,7 6,7.5C 5.33333,14.8333 5.33333,22.1667 6,29.5C 9.89204,29.829 13.392,30.829 16.5,32.5C 13.0242,33.6433 9.35754,33.8099 5.5,33C 4.29857,32.0975 3.46524,30.9308 3,29.5C 2.33333,21.8333 2.33333,14.1667 3,6.5C 3.37424,5.58377 3.87424,4.75044 4.5,4C 19.0733,2.36737 33.7399,2.03403 48.5,3C 50.3333,3.5 51.5,4.66667 52,6.5C 52.6667,14.5 52.6667,22.5 52,30.5C 50.3331,32.6278 48.1664,33.9611 45.5,34.5C 43.4939,37.8292 41.1606,40.8292 38.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 47.5,6.5 C 35.8333,6.5 24.1667,6.5 12.5,6.5C 12.2529,9.93869 12.5863,13.272 13.5,16.5C 12.596,17.209 12.2627,18.209 12.5,19.5C 17.8333,19.5 23.1667,19.5 28.5,19.5C 25.023,20.3227 21.3563,20.8227 17.5,21C 18.1667,21.3333 18.8333,21.6667 19.5,22C 29.4944,22.4998 39.4944,22.6665 49.5,22.5C 49.6633,24.8568 49.4966,27.1902 49,29.5C 44.1549,30.8391 40.6549,33.8391 38.5,38.5C 36.5879,36.3428 34.9213,34.0094 33.5,31.5C 29.2047,30.3391 24.8713,30.1725 20.5,31C 19.944,31.3826 19.6107,31.8826 19.5,32.5C 18.5,32.5 17.5,32.5 16.5,32.5C 13.392,30.829 9.89204,29.829 6,29.5C 5.33333,22.1667 5.33333,14.8333 6,7.5C 6.5,7 7,6.5 7.5,6C 21.0064,5.17296 34.3397,5.33963 47.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient-lighter)",
    d: "M 47.5,6.5 C 48.1174,6.61071 48.6174,6.94404 49,7.5C 49.4993,12.4889 49.6659,17.4889 49.5,22.5C 39.4944,22.6665 29.4944,22.4998 19.5,22C 18.8333,21.6667 18.1667,21.3333 17.5,21C 21.3563,20.8227 25.023,20.3227 28.5,19.5C 28.5,18.5 28.5,17.5 28.5,16.5C 23.5,16.5 18.5,16.5 13.5,16.5C 12.5863,13.272 12.2529,9.93869 12.5,6.5C 24.1667,6.5 35.8333,6.5 47.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 18.5,10.5 C 27.1667,10.5 35.8333,10.5 44.5,10.5C 44.5,11.5 44.5,12.5 44.5,13.5C 35.8333,13.5 27.1667,13.5 18.5,13.5C 18.5,12.5 18.5,11.5 18.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#border-gradient)",
    d: "M 94.5,21.5 C 93.79,19.1073 93.1233,16.6073 92.5,14C 84.5069,13.5003 76.5069,13.3336 68.5,13.5C 66.2075,13.2436 64.0408,13.5769 62,14.5C 61.3333,20.1667 61.3333,25.8333 62,31.5C 69.0787,32.4799 76.2454,32.8132 83.5,32.5C 83.238,33.9778 83.5713,35.3112 84.5,36.5C 86.5738,33.9221 89.2405,32.4221 92.5,32C 93.4231,29.9592 93.7564,27.7925 93.5,25.5C 93.5,24.8333 93.8333,24.5 94.5,24.5C 96.0265,25.4919 96.6932,26.9919 96.5,29C 96.3968,30.5615 96.0634,32.0615 95.5,33.5C 90.4855,36.1911 85.4855,38.8578 80.5,41.5C 80.5,39.5 80.5,37.5 80.5,35.5C 74.1579,35.6662 67.8246,35.4995 61.5,35C 60.6667,34.1667 59.8333,33.3333 59,32.5C 58.3333,26.1667 58.3333,19.8333 59,13.5C 59.8333,12.6667 60.6667,11.8333 61.5,11C 72.1667,10.3333 82.8333,10.3333 93.5,11C 95.8146,12.2957 96.8146,14.2957 96.5,17C 96.6932,19.0081 96.0265,20.5081 94.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 68.5,13.5 C 68.3379,15.5273 68.5045,17.5273 69,19.5C 69.3826,18.944 69.8826,18.6107 70.5,18.5C 70.5,19.5 70.5,20.5 70.5,21.5C 71.1667,22.5 71.8333,23.5 72.5,24.5C 70.1667,24.5 67.8333,24.5 65.5,24.5C 65.5,25.5 65.5,26.5 65.5,27.5C 70.9443,28.1083 75.9443,27.4417 80.5,25.5C 82.0418,26.3007 83.7085,26.634 85.5,26.5C 86.5,27.8333 87.5,27.8333 88.5,26.5C 90.2915,26.634 91.9582,26.3007 93.5,25.5C 93.7564,27.7925 93.4231,29.9592 92.5,32C 89.2405,32.4221 86.5738,33.9221 84.5,36.5C 83.5713,35.3112 83.238,33.9778 83.5,32.5C 76.2454,32.8132 69.0787,32.4799 62,31.5C 61.3333,25.8333 61.3333,20.1667 62,14.5C 64.0408,13.5769 66.2075,13.2436 68.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#dark-pink-gradient-lighter)",
    d: "M 68.5,13.5 C 76.5069,13.3336 84.5069,13.5003 92.5,14C 93.1233,16.6073 93.79,19.1073 94.5,21.5C 94.5,22.5 94.5,23.5 94.5,24.5C 93.8333,24.5 93.5,24.8333 93.5,25.5C 91.9582,26.3007 90.2915,26.634 88.5,26.5C 87.5,23.8333 86.5,23.8333 85.5,26.5C 83.7085,26.634 82.0418,26.3007 80.5,25.5C 78.0521,24.5269 75.3854,24.1936 72.5,24.5C 71.8333,23.5 71.1667,22.5 70.5,21.5C 76.8333,21.5 83.1667,21.5 89.5,21.5C 89.5,20.5 89.5,19.5 89.5,18.5C 83.1667,18.5 76.8333,18.5 70.5,18.5C 69.8826,18.6107 69.3826,18.944 69,19.5C 68.5045,17.5273 68.3379,15.5273 68.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 13.5,16.5 C 18.5,16.5 23.5,16.5 28.5,16.5C 28.5,17.5 28.5,18.5 28.5,19.5C 23.1667,19.5 17.8333,19.5 12.5,19.5C 12.2627,18.209 12.596,17.209 13.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 34.5,16.5 C 37.8333,16.5 41.1667,16.5 44.5,16.5C 44.5,17.5 44.5,18.5 44.5,19.5C 41.1667,19.5 37.8333,19.5 34.5,19.5C 34.5,18.5 34.5,17.5 34.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 70.5,18.5 C 76.8333,18.5 83.1667,18.5 89.5,18.5C 89.5,19.5 89.5,20.5 89.5,21.5C 83.1667,21.5 76.8333,21.5 70.5,21.5C 70.5,20.5 70.5,19.5 70.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 12.5,23.5 C 17.8746,23.1718 23.2079,23.5052 28.5,24.5C 25.8333,24.8333 23.1667,25.1667 20.5,25.5C 17.4098,25.4783 14.7432,24.8117 12.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 32.5,23.5 C 33.675,23.281 34.675,23.6143 35.5,24.5C 33.9483,25.7979 32.9483,25.4646 32.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 38.5,23.5 C 39.675,23.281 40.675,23.6143 41.5,24.5C 39.9483,25.7979 38.9483,25.4646 38.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 72.5,24.5 C 75.3854,24.1936 78.0521,24.5269 80.5,25.5C 75.9443,27.4417 70.9443,28.1083 65.5,27.5C 65.5,26.5 65.5,25.5 65.5,24.5C 67.8333,24.5 70.1667,24.5 72.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "black",
    d: "M 88.5,26.5 C 87.5,27.8333 86.5,27.8333 85.5,26.5C 86.5,23.8333 87.5,23.8333 88.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#border-gradient)",
    d: "M 31.5,38.5 C 27.6877,39.3238 23.6877,39.8238 19.5,40C 18.0577,40.3768 17.0577,41.2101 16.5,42.5C 15.3592,45.6399 15.1925,48.9733 16,52.5C 16.8333,53.3333 17.6667,54.1667 18.5,55C 23.5,55.6667 28.5,55.6667 33.5,55C 36.3208,52.8587 37.6541,50.0254 37.5,46.5C 37.8333,46.5 38.1667,46.5 38.5,46.5C 39.6491,46.7911 40.3158,47.6244 40.5,49C 39.2093,53.9431 36.7093,58.1097 33,61.5C 32.5172,62.448 32.3505,63.448 32.5,64.5C 35.3903,64.278 38.057,64.9447 40.5,66.5C 42.7964,69.5335 44.6297,72.8668 46,76.5C 50.9399,73.1516 54.7733,73.9849 57.5,79C 57.0969,80.4728 56.4303,81.8061 55.5,83C 50.7019,85.2726 45.7019,86.2726 40.5,86C 40,85.5 39.5,85 39,84.5C 38.51,85.7932 38.3433,87.1266 38.5,88.5C 38.5,90.1667 38.5,91.8333 38.5,93.5C 57.1667,93.5 75.8333,93.5 94.5,93.5C 96.5492,93.7058 96.8825,94.5391 95.5,96C 75.3291,96.8291 55.3291,96.6625 35.5,95.5C 35.5,89.8333 35.5,84.1667 35.5,78.5C 35.5,77.5 35.5,76.5 35.5,75.5C 36.675,75.281 37.675,75.6143 38.5,76.5C 40.0198,78.6621 41.0198,80.9954 41.5,83.5C 43.861,83.3259 46.1944,82.9926 48.5,82.5C 48.5,81.5 48.5,80.5 48.5,79.5C 46.712,79.7852 45.0453,79.4519 43.5,78.5C 42.3011,75.0561 40.6345,71.8895 38.5,69C 35.8333,68.3333 33.1667,68.3333 30.5,69C 29.4711,70.6984 27.9711,71.5317 26,71.5C 23.5903,70.2524 21.0903,69.2524 18.5,68.5C 15.6755,68.0807 13.5088,69.0807 12,71.5C 11.5003,79.4931 11.3336,87.4931 11.5,95.5C 9.03362,96.6341 6.36695,96.8007 3.5,96C 2.11746,94.5391 2.45079,93.7058 4.5,93.5C 6.16667,93.5 7.83333,93.5 9.5,93.5C 9.5,92.5 9.5,91.5 9.5,90.5C 7.83333,90.5 6.16667,90.5 4.5,90.5C 2.9153,89.9976 2.4153,88.9976 3,87.5C 4.69946,86.5939 6.5328,86.2606 8.5,86.5C 8.08995,80.3792 8.58995,74.3792 10,68.5C 12.6417,65.9712 15.8084,64.9712 19.5,65.5C 19.6567,64.1266 19.49,62.7932 19,61.5C 17.264,58.6329 15.264,55.9663 13,53.5C 11.1134,38.205 17.2801,33.205 31.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient-mod)",
    d: "M 31.5,38.5 C 32.5,38.5 33.5,38.5 34.5,38.5C 35.604,40.3885 36.9373,42.0552 38.5,43.5C 38.5,44.5 38.5,45.5 38.5,46.5C 38.1667,46.5 37.8333,46.5 37.5,46.5C 36.596,47.209 36.2627,48.209 36.5,49.5C 31.4889,49.6659 26.4889,49.4993 21.5,49C 18.5066,47.8415 16.8399,45.6748 16.5,42.5C 17.0577,41.2101 18.0577,40.3768 19.5,40C 23.6877,39.8238 27.6877,39.3238 31.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#border-gradient)",
    d: "M 90.5,83.5 C 88.8235,82.8166 88.1568,81.4832 88.5,79.5C 87.5,79.5 86.5,79.5 85.5,79.5C 85.8432,81.4832 85.1765,82.8166 83.5,83.5C 82.5166,79.7016 82.1832,75.7016 82.5,71.5C 83.5,71.5 84.5,71.5 85.5,71.5C 85.5,73.1667 85.5,74.8333 85.5,76.5C 86.5,76.5 87.5,76.5 88.5,76.5C 89.3815,72.0907 88.0482,68.5907 84.5,66C 83.0563,65.2195 81.723,65.3861 80.5,66.5C 79.8551,67.646 79.0217,68.646 78,69.5C 77.5008,74.1548 77.3342,78.8215 77.5,83.5C 76.5,83.5 75.5,83.5 74.5,83.5C 74.6658,78.8215 74.4992,74.1548 74,69.5C 70.7567,64.3005 67.4234,64.3005 64,69.5C 63.5034,71.8098 63.3367,74.1432 63.5,76.5C 64.5,76.5 65.5,76.5 66.5,76.5C 66.5,74.8333 66.5,73.1667 66.5,71.5C 67.791,71.2627 68.791,71.596 69.5,72.5C 69.5,77.5 69.5,82.5 69.5,87.5C 76.5,87.5 83.5,87.5 90.5,87.5C 92.604,87.2011 94.604,87.5344 96.5,88.5C 96.1445,89.5223 95.4778,90.189 94.5,90.5C 79.5,89.8333 64.5,89.1667 49.5,88.5C 49.6107,87.8826 49.944,87.3826 50.5,87C 53.8168,86.5017 57.1501,86.335 60.5,86.5C 60.3339,80.8236 60.5006,75.1569 61,69.5C 61.8466,67.8068 62.6799,66.1401 63.5,64.5C 65.472,63.549 67.472,62.549 69.5,61.5C 66.3069,53.3821 68.9736,49.3821 77.5,49.5C 77.8333,53.1667 79.8333,55.1667 83.5,55.5C 83.6816,57.5914 83.3482,59.5914 82.5,61.5C 83.6888,62.4287 85.0222,62.762 86.5,62.5C 88.8122,53.1078 85.4789,47.1078 76.5,44.5C 67.554,46.0338 63.7207,51.3671 65,60.5C 64.6174,61.056 64.1174,61.3893 63.5,61.5C 60.3758,50.4309 64.5425,43.7643 76,41.5C 87.051,43.5802 91.7176,50.2468 90,61.5C 88.0962,64.0675 88.4295,66.4008 91,68.5C 91.8163,73.6842 91.6497,78.6842 90.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 16.5,42.5 C 16.8399,45.6748 18.5066,47.8415 21.5,49C 26.4889,49.4993 31.4889,49.6659 36.5,49.5C 36.2627,48.209 36.596,47.209 37.5,46.5C 37.6541,50.0254 36.3208,52.8587 33.5,55C 28.5,55.6667 23.5,55.6667 18.5,55C 17.6667,54.1667 16.8333,53.3333 16,52.5C 15.1925,48.9733 15.3592,45.6399 16.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 63.5,64.5 C 63.5,63.5 63.5,62.5 63.5,61.5C 64.1174,61.3893 64.6174,61.056 65,60.5C 63.7207,51.3671 67.554,46.0338 76.5,44.5C 85.4789,47.1078 88.8122,53.1078 86.5,62.5C 85.0222,62.762 83.6888,62.4287 82.5,61.5C 83.3482,59.5914 83.6816,57.5914 83.5,55.5C 79.8333,55.1667 77.8333,53.1667 77.5,49.5C 68.9736,49.3821 66.3069,53.3821 69.5,61.5C 67.472,62.549 65.472,63.549 63.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8cb24",
    d: "M 72.5,52.5 C 73.675,52.281 74.675,52.6143 75.5,53.5C 76.1322,55.9647 77.6322,57.6314 80,58.5C 78.2269,63.1751 75.5603,63.5084 72,59.5C 71.2967,57.0709 71.4634,54.7375 72.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4ac32",
    d: "M 20.5,59.5 C 23.9758,58.3567 27.6425,58.1901 31.5,59C 27.9881,63.4553 24.3215,63.622 20.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c38c46",
    d: "M 22.5,64.5 C 24.924,64.1924 27.2573,64.5258 29.5,65.5C 26.5332,69.6224 24.1998,69.289 22.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#shirt)",
    d: "M 18.5,68.5 C 18.7132,77.7717 23.3799,81.605 32.5,80C 33.5266,79.4867 34.5266,78.9867 35.5,78.5C 35.5,84.1667 35.5,89.8333 35.5,95.5C 29.8333,95.5 24.1667,95.5 18.5,95.5C 18.5,89.1667 18.5,82.8333 18.5,76.5C 17.5,76.5 16.5,76.5 15.5,76.5C 15.5,82.8333 15.5,89.1667 15.5,95.5C 14.1667,95.5 12.8333,95.5 11.5,95.5C 11.3336,87.4931 11.5003,79.4931 12,71.5C 13.5088,69.0807 15.6755,68.0807 18.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#shirt)",
    d: "M 18.5,68.5 C 21.0903,69.2524 23.5903,70.2524 26,71.5C 27.9711,71.5317 29.4711,70.6984 30.5,69C 33.1667,68.3333 35.8333,68.3333 38.5,69C 40.6345,71.8895 42.3011,75.0561 43.5,78.5C 45.0453,79.4519 46.712,79.7852 48.5,79.5C 48.5,80.5 48.5,81.5 48.5,82.5C 46.1944,82.9926 43.861,83.3259 41.5,83.5C 41.0198,80.9954 40.0198,78.6621 38.5,76.5C 37.675,75.6143 36.675,75.281 35.5,75.5C 35.5,76.5 35.5,77.5 35.5,78.5C 34.5266,78.9867 33.5266,79.4867 32.5,80C 23.3799,81.605 18.7132,77.7717 18.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#shirt)",
    d: "M 83.5,83.5 C 83.5,84.5 83.5,85.5 83.5,86.5C 79.1667,86.5 74.8333,86.5 70.5,86.5C 70.8195,81.6367 70.4861,76.97 69.5,72.5C 68.791,71.596 67.791,71.2627 66.5,71.5C 66.5,73.1667 66.5,74.8333 66.5,76.5C 65.5,76.5 64.5,76.5 63.5,76.5C 63.3367,74.1432 63.5034,71.8098 64,69.5C 67.4234,64.3005 70.7567,64.3005 74,69.5C 74.4992,74.1548 74.6658,78.8215 74.5,83.5C 75.5,83.5 76.5,83.5 77.5,83.5C 77.3342,78.8215 77.5008,74.1548 78,69.5C 79.0217,68.646 79.8551,67.646 80.5,66.5C 81.723,65.3861 83.0563,65.2195 84.5,66C 88.0482,68.5907 89.3815,72.0907 88.5,76.5C 87.5,76.5 86.5,76.5 85.5,76.5C 85.5,74.8333 85.5,73.1667 85.5,71.5C 84.5,71.5 83.5,71.5 82.5,71.5C 82.1832,75.7016 82.5166,79.7016 83.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d38f3c",
    d: "M 74.5,66.5 C 75.2506,65.4265 76.2506,65.2599 77.5,66C 76.6477,67.7284 75.6477,67.895 74.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d549e",
    d: "M 18.5,95.5 C 17.3478,96.625 16.3478,96.625 15.5,95.5C 15.5,89.1667 15.5,82.8333 15.5,76.5C 16.5,76.5 17.5,76.5 18.5,76.5C 18.5,82.8333 18.5,89.1667 18.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1c722",
    d: "M 51.5,77.5 C 54.6741,77.9522 55.0075,78.9522 52.5,80.5C 51.6143,79.675 51.281,78.675 51.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4c60c",
    d: "M 90.5,83.5 C 90.5,84.5 90.5,85.5 90.5,86.5C 88.1667,86.5 85.8333,86.5 83.5,86.5C 83.5,85.5 83.5,84.5 83.5,83.5C 85.1765,82.8166 85.8432,81.4832 85.5,79.5C 86.5,79.5 87.5,79.5 88.5,79.5C 88.1568,81.4832 88.8235,82.8166 90.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1c816",
    d: "M 63.5,79.5 C 64.5,79.5 65.5,79.5 66.5,79.5C 66.5,82.1667 66.5,84.8333 66.5,87.5C 65.5,87.5 64.5,87.5 63.5,87.5C 63.5,84.8333 63.5,82.1667 63.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c8e59",
    d: "M 69.5,72.5 C 70.4861,76.97 70.8195,81.6367 70.5,86.5C 74.8333,86.5 79.1667,86.5 83.5,86.5C 85.8333,86.5 88.1667,86.5 90.5,86.5C 90.5,86.8333 90.5,87.1667 90.5,87.5C 83.5,87.5 76.5,87.5 69.5,87.5C 69.5,82.5 69.5,77.5 69.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73ac3e",
    d: "M 4.5,90.5 C 6.16667,90.5 7.83333,90.5 9.5,90.5C 9.5,91.5 9.5,92.5 9.5,93.5C 7.83333,93.5 6.16667,93.5 4.5,93.5C 4.5,92.5 4.5,91.5 4.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#brown)",
    d: "M 38.5,88.5 C 42.1667,88.5 45.8333,88.5 49.5,88.5C 64.5,89.1667 79.5,89.8333 94.5,90.5C 94.5,91.5 94.5,92.5 94.5,93.5C 75.8333,93.5 57.1667,93.5 38.5,93.5C 38.5,91.8333 38.5,90.1667 38.5,88.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Consultation100);
export default __webpack_public_path__ + "static/media/icons8-consultation-100.9c81e8efcc9ced41f59e958d2633c8d4.svg";
export { ForwardRef as ReactComponent };